import React, { useEffect, useState } from 'react';
import './BackgroundEffects.css';

const BackgroundEffects = () => {
  const [particles, setParticles] = useState([]);

  useEffect(() => {
    // Generate random floating particles
    const generateParticles = () => {
      const newParticles = [];
      for (let i = 0; i < 20; i++) {
        newParticles.push({
          id: i,
          left: Math.random() * 100,
          top: Math.random() * 100,
          delay: Math.random() * 6,
          duration: 4 + Math.random() * 4,
        });
      }
      setParticles(newParticles);
    };

    generateParticles();
  }, []);

  return (
    <div className="background-effects">
      {/* Mesh gradient background */}
      <div className="background-mesh" />


      {/* Floating particles */}
      <div className="particles-container">
        {particles.map((particle) => (
          <div
            key={particle.id}
            className="floating-particle"
            style={{
              left: `${particle.left}%`,
              top: `${particle.top}%`,
              animationDelay: `${particle.delay}s`,
              animationDuration: `${particle.duration}s`,
            }}
          />
        ))}
      </div>

      {/* Glow orbs */}
      <div className="glow-orbs">
        <div className="glow-orb glow-orb-1" />
        <div className="glow-orb glow-orb-2" />
        <div className="glow-orb glow-orb-3" />
      </div>
    </div>
  );
};

export default BackgroundEffects; 